/**
 * check if object has key for resolving TS errors
 *
 * @param {Object} obj проверяемый объект
 *
 * @param {string} key ключ свойства
 *
 * @return {boolean}
 *
 * @example camelToSnake('myArg') => 'my_arg';
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const objectHasKey = <O>(obj: O, key: keyof any): key is keyof O => {
	return key in obj;
};
